import _ from 'underscore';
import $ from 'jquery';
import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';

// focusable also means clickable.
function isFocusable(ele) {
  return $(ele).is('a[href], area[href], button, details, input, iframe, select, textarea, [tabindex], [onclick], [data-inline=1], .grid-editable-cell');
}

function isSelectable(selectable, item) {
  if (_.isFunction(selectable)) {
    return !_.isEmpty(item) && selectable(item);
  }

  // if selectable is null or undefined, the item can be selected.
  return selectable !== false;
}

export const assistedSelectionPlugin = defineGridPlugin(
  'assisted-selection',
  ['gridView'],
  (gridView) => {
    const assistedSelection = {
      name: 'assisted-selection',
      handler(state) {
        const selection = gridView.get('selection');

        if (selection === false || (_.isObject(selection) && selection.enabled === false)) {
          return state;
        }

        const events = {
          'click tbody tr[data-key], .tbody .tr[data-key]': (e) => {
            const parents = $(e.target).parentsUntil('tr, .tr');
            const focusableElems = _.find(
              _.union(_.toArray(parents), [e.target]),
              ele => isFocusable(ele)
            );

            if (focusableElems) {
              return;
            }

            setTimeout(() => {
              const sel = window.getSelection();
              const { selectable } = selection;
              if (sel.isCollapsed || e.shiftKey) {
                const key = this.keyOfElement(e.target);
                const rangeSelection = gridView.get('rangeSelection');

                if (!e.shiftKey) {
                  if (isSelectable(selectable, gridView.itemWithKey(key))) {
                    rangeSelection.preSelect = key;

                    if (_.contains(gridView.selectedKeys(), key)) {
                      if (!selection.single) {
                        gridView.deselectRow(key);
                      }
                    } else {
                      gridView.selectRow(key);
                    }
                  }
                } else {
                  const { preSelect, preShiftSelect } = rangeSelection;
                  const allKey = _.chain(gridView.items.slice())
                    .filter(selectable)
                    .map(_.property(gridView.primaryKey))
                    .map(String)
                    .value();
                  const preIndex = allKey.indexOf(preSelect);
                  const curIndex = allKey.indexOf(key);

                  if (preShiftSelect) {
                    const preShiftIndex = allKey.indexOf(preShiftSelect);
                    _.each(allKey.slice(
                      Math.min(preIndex, preShiftIndex),
                      Math.max(preIndex, preShiftIndex) + 1
                    ), (k) => {
                      gridView.deselectRow(k);
                    });
                  }

                  _.each(allKey.slice(
                    Math.min(preIndex, curIndex),
                    Math.max(preIndex, curIndex) + 1
                  ), (k) => {
                    gridView.selectRow(k);
                  });

                  rangeSelection.preShiftSelect = key;
                }
              }

              gridView.trigger('change:row.check.list');
            }, 100);
          },
        };

        _.defaults(events, state.events);

        return _.defaults({ events }, state);
      },
      defaults: {},
    };

    gridView.pipeContentProjections(assistedSelection);
  }
);

